import { render, staticRenderFns } from "./security-auth-management.vue?vue&type=template&id=637c77c3&scoped=true&"
import script from "./security-auth-management.vue?vue&type=script&lang=js&"
export * from "./security-auth-management.vue?vue&type=script&lang=js&"
import style0 from "./security-auth-management.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./security-auth-management.vue?vue&type=style&index=1&id=637c77c3&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "637c77c3",
  null
  
)

export default component.exports